import React from 'react';
import { motion } from 'framer-motion';
import { Wrench, Sparkles, Hammer } from 'lucide-react';
const services = [{
  title: 'Deck Removal',
  description: "Safe and thorough removal of old, damaged, or worn-out decking materials without harming your boat's underlying structure.",
  icon: Wrench
}, {
  title: 'Deck Restoration',
  description: 'Bring your existing deck back to its former glory. We repair, clean, and treat surfaces to look brand new.',
  icon: Sparkles
}, {
  title: 'Deck Installation',
  description: 'Precision installation of premium, durable new decking materials tailored to fit your boat perfectly.',
  icon: Hammer
}];
export function Services() {
  return <section id="services" className="py-24 bg-ocean-900 relative" data-id="element-85">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86">
        <div className="text-center mb-16" data-id="element-87">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-88">
            Our Services
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="w-24 h-1 bg-sun-500 mx-auto rounded-full" data-id="element-89"></motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-90">
          {services.map((service, index) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-ocean-800/50 border border-ocean-400/20 rounded-2xl p-8 hover:border-ocean-400/50 hover:bg-ocean-800 transition-all duration-300 group shadow-lg" data-id="element-91">
              <div className="w-16 h-16 bg-ocean-900 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 border border-ocean-400/30" data-id="element-92">
                <service.icon className="w-8 h-8 text-sun-400" data-id="element-93" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-94">
                {service.title}
              </h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-95">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}